const REACT_APP_CMS_HOST = process.env.REACT_APP_CMS_HOST;

export function getGallery(partition) {
  const gallery = partition?.attributes?.gallery?.data;

  if (Array.isArray(gallery)) {
    return gallery.filter(
      (image) => image?.attributes?.formats?.thumbnail?.url && image?.id
    );
  } else {
    return [];
  }
}

export function getFlatImages(gallery = []) {
  if (Array.isArray(gallery)) {
    return gallery
      .map((image) => {
        return image?.attributes?.formats?.thumbnail?.url;
      })
      .filter(Boolean);
  }
  return [];
}

export function preloadImage(src, { signal } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;

    if (img.complete) {
      resolve(img);
      return;
    }

    img.onload = function () {
      resolve(img);
    };
    
    img.onerror = img.onabort = function () {
      reject(src);
    };

    if (signal) {
      signal.addEventListener("abort", () => {
        reject("Aborted");
        img.src = "";
      });
    }
  });
}

export async function preloadImages(images, { setProgress, signal }) {
  const imagesPromiseList = [];

  for (let i = 0; i < images.length; i++) {
    const img = images[i];

    imagesPromiseList.push(
      await preloadImage(img, {signal}).then(() => {
        setProgress((i + 1) * (100 / images.length));
      })
    );
  }

  imagesPromiseList.push(
    new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 1000);
    })
  );
}
